<template>
  <link
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css"
    rel="stylesheet"
  />
  <div :style="{ background: themedBackground?.mainContent }" v-if="isLoaded">
    <Navbar :list-items="listItems" v-if="!renderContainerByDNS" />

    <div class="sm:mt-0" :class="renderContainerByDNS ? 'mt-0' : 'mt-[60px]'">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import Navbar from "@/features/public/components/Navbar.vue";
import { defineProps, ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";

const containerByDNS = ref<Profile>(null);
const store = useStore();

interface ListItem {
  name: string;
  link: string;
  icon: string;
}
const isLoaded = ref(false);

const listItems: ListItem[] = [
  // {
  //   name: "Partner",
  //   link: "/positions",
  //   icon: "fas fa-handshake",
  // },
  // {
  //   name: "Karriär",
  //   link: "/positions",
  //   icon: "fas fa-briefcase",
  // },
  // {
  //   name: "Om oss",
  //   link: "/positions",
  //   icon: "fas fa-info-circle",
  // },
  // {
  //   name: "Kontakt",
  //   link: "/positions",
  //   icon: "fas fa-phone",
  // },
];

const renderContainerByDNS = ref(false);
onMounted(async () => {
  if (store.getters.publicContainer.id === undefined) {
    await store.dispatch("loadPublicContainerByName", "");
  }

  if (store.getters.publicContainer.id === 0) {
    renderContainerByDNS.value = false;
  } else {
    renderContainerByDNS.value = true;
  }
  isLoaded.value = true;
});

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

// const test = ref('#FFB6C180');
const themedBackground = computed(
  () => store.getters.getContainerThemedBackground
);
</script>
